import React from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import contele_system from 'assets/images/contele_system.png';
import contele_tracker from 'assets/images/contele_tracker.png';
import contele_cameras from 'assets/images/contele_cameras.png';
import {
  ActionPortal,
  ButtonWithIcon,
  Checkbox,
  DefaultActionButtons,
  Form,
  Icon,
  MaskedInput,
  Step,
  Text,
} from 'components';

import { Gray, Orange, Purple } from 'constants/colors';
import { StepPropTypes } from 'constants/propTypes';


const STEPS = {
  EQUIPMENT_SHIPPING: 1,
  TRACKER_MODELS_SELECTION: 2,
  CAMERAS_MODELS_SELECTION: 3,
  AUTOMATIC_FINES_UPDATE: 5,
};

const formValidationSchema = yup
  .object()
  .shape({
    conteleSystemCount: yup.number().integer().moreThan(-1),
    conteleTrackerCount: yup.number().integer().moreThan(-1),
    conteleCamerasCount: yup.number().integer().moreThan(-1),
    acceptTerms: yup.boolean().oneOf([true], 'Você deve aceitar os termos para prosseguir.'),
  })
  .test('sum', (value) => {
    if (!value) return true;
    const {
      conteleSystemCount,
      conteleTrackerCount,
      conteleCamerasCount,
      acceptTerms,
    } = value;

    const vehicleCountByType = [
      conteleSystemCount,
      conteleTrackerCount,
      conteleCamerasCount,
    ].reduce((sum, cur) => sum + parseInt(cur || 0, 10), 0);

    return vehicleCountByType >= 4 && acceptTerms;
  });

export default function VehicleManager(props) {
  const {
    theme,
    onSubmit,
    onCancel,
    initialValues: {
      vehicleManager,
      quantityTypes,
      cameraTypes,
    },
  } = props;

  const {
    control, formState, handleSubmit, watch, setValue, register,
  } = useForm({
    mode: 'all',
    defaultValues: vehicleManager || {
      conteleSystemCount: 0,
      conteleTrackerCount: 0,
      conteleCamerasCount: 0,
      acceptTerms: false,
    },
    resolver: yupResolver(formValidationSchema),
  });

  const conteleSystemCount = watch('conteleSystemCount');
  const conteleTrackerCount = watch('conteleTrackerCount');
  const conteleCamerasCount = watch('conteleCamerasCount');

  const { isValid } = formState;

  const calculateNextStepPosition = (values) => {
    const { conteleSystemCount = 0, conteleTrackerCount = 0, conteleCamerasCount = 0 } = values;

    if (conteleSystemCount > 0 && conteleTrackerCount === 0 && conteleCamerasCount === 0) {
      return STEPS.AUTOMATIC_FINES_UPDATE;
    }

    if (conteleTrackerCount > 0 && conteleCamerasCount === 0) {
      if (conteleTrackerCount >= 15) return STEPS.EQUIPMENT_SHIPPING;
      return STEPS.TRACKER_MODELS_SELECTION;
    }

    if (conteleTrackerCount === 0 && conteleCamerasCount > 0) {
      if (conteleCamerasCount >= 10) return STEPS.EQUIPMENT_SHIPPING;
      return STEPS.CAMERAS_MODELS_SELECTION;
    }

    return STEPS.TRACKER_MODELS_SELECTION;
  };

  const submitForm = (e) => {
    e.preventDefault();
    handleSubmit(onSubmit)();
  };

  const handleFormSubmitWithReset = (values) => {
    const hasTrackerTypesConfigured = quantityTypes &&
      ((quantityTypes.tracker2GCount || 0) + (quantityTypes.tracker4GCount || 0) + (quantityTypes.trackerPlugAndPlayCount || 0)) > 0;

    const hasCameraTypesConfigured = cameraTypes &&
      ((cameraTypes.conteleCamCount || 0) + (cameraTypes.conteleCamIaCount || 0)) > 0;

    const trackerCountChanged = values.conteleTrackerCount !== (vehicleManager?.conteleTrackerCount || 0);
    const cameraCountChanged = values.conteleCamerasCount !== (vehicleManager?.conteleCamerasCount || 0);

    const totalEquipmentCountChanged = trackerCountChanged || cameraCountChanged;

    const formValues = {
      ...values,
      nextStepIndexPosition: calculateNextStepPosition(values),
    };

    const resetData = {
      ...(hasTrackerTypesConfigured && trackerCountChanged && { quantityTypes: null }),
      ...(hasCameraTypesConfigured && cameraCountChanged && { cameraTypes: null }),
      ...(totalEquipmentCountChanged && { trackersBatch: null }),
      ...(totalEquipmentCountChanged && { blocker: null }),
    };

    onSubmit({ ...formValues, ...resetData });
  };

  return (
    <div style={{ height: '100%', backgroundColor: Gray[200] }}>
      <Step
        headerTitle="Escolha a quantidade da sua modalidade"
        style={{
          backgroundColor: Gray[200],
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Form onKeyPress={(e) => e.key === 'Enter' && submitForm(e)}>
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            width: '1048px',
            minHeight: '700px',
            border: `1px solid ${Gray[250]}`,
            gap: '16px',
            borderRadius: '5px',
            backgroundColor: Gray[100],
            padding: '20px',
          }}
          >

            <div style={{
              display: 'flex',
              gap: '20px',
              justifyContent: 'space-between',
            }}
            >
              <div style={{
                width: '454px',
                height: '450px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              >
                <img
                  src={contele_system}
                  alt="Contele System"
                  style={{ width: '100%', height: '200px' }}
                />
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
                >
                  <Text
                    color={Gray[500]}
                    fontSize="18px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Contele System
                  </Text>
                  <Text
                    color={Gray[400]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="400"
                    textAlign="center"
                  >
                    Modalidade do Contele Fleet que não utiliza nenhum equipamento físico.
                  </Text>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
                >
                  <Text
                    color={Gray[500]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="600"
                  >
                    Quantidade de veículos do Contele System
                  </Text>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <ButtonWithIcon
                      icon="minus"
                      customBackgroundColor={Gray[100]}
                      border={`1px solid ${Gray[250]}`}
                      customIconColor={Gray[400]}
                      height="32px"
                      iconOptions={{ width: '14px', height: '14px' }}
                      onClick={() => {
                        if (conteleSystemCount === 0) return;
                        setValue('conteleSystemCount', conteleSystemCount - 1, { shouldValidate: true });
                      }}
                    />
                    <MaskedInput
                      control={control}
                      name="conteleSystemCount"
                      placeholder="Digite a quantidade de veículos"
                      format="numeric"
                      containerWidth="100%"
                      style={{ border: `1px solid ${Gray[250]}`, borderRadius: '5px' }}
                    />
                    <ButtonWithIcon
                      icon="plus"
                      customBackgroundColor={Gray[100]}
                      border={`1px solid ${Gray[250]}`}
                      customIconColor={Gray[400]}
                      height="32px"
                      iconOptions={{ width: '14px', height: '14px' }}
                      onClick={() => setValue('conteleSystemCount', conteleSystemCount + 1, { shouldValidate: true })}
                    />
                  </div>
                </div>
              </div>

              <div style={{
                width: '454px',
                height: '450px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              >
                <img
                  src={contele_tracker}
                  alt="Contele Tracker"
                  style={{ width: '100%', height: '200px' }}
                />
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
                >
                  <Text
                    color={Gray[500]}
                    fontSize="18px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Contele Tracker
                  </Text>
                  <Text
                    color={Gray[400]}
                    fontSize="14px"
                    lineHeight="19px"
                    fontWeight="400"
                    textAlign="center"
                  >
                    Modalidade do Contele Fleet que engloba todas as funções do Contele System além de outros recursos devido à utilização do rastreador instalado no veículo.
                  </Text>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
                >
                  <Text
                    color={Gray[500]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="600"
                  >
                    Quantidade de veículos do Contele Tracker
                  </Text>
                  <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                    <ButtonWithIcon
                      icon="minus"
                      customBackgroundColor={Gray[100]}
                      border={`1px solid ${Gray[250]}`}
                      customIconColor={Gray[400]}
                      height="32px"
                      iconOptions={{ width: '14px', height: '14px' }}
                      onClick={() => {
                        if (conteleTrackerCount === 0) return;
                        setValue('conteleTrackerCount', conteleTrackerCount - 1, { shouldValidate: true });
                      }}
                    />
                    <MaskedInput
                      control={control}
                      name="conteleTrackerCount"
                      placeholder="Digite a quantidade de veículos"
                      format="numeric"
                      containerWidth="100%"
                      style={{ border: `1px solid ${Gray[250]}`, borderRadius: '5px' }}
                    />
                    <ButtonWithIcon
                      icon="plus"
                      customBackgroundColor={Gray[100]}
                      border={`1px solid ${Gray[250]}`}
                      customIconColor={Gray[400]}
                      height="32px"
                      iconOptions={{ width: '14px', height: '14px' }}
                      onClick={() => setValue('conteleTrackerCount', conteleTrackerCount + 1, { shouldValidate: true })}
                    />
                  </div>
                </div>
              </div>

              <div style={{
                width: '454px',
                height: '450px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
              }}
              >
                <img
                  src={contele_cameras}
                  alt="Contele Câmeras"
                  style={{ width: '100%', height: '200px' }}
                />
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                }}
                >
                  <Text
                    color={Gray[500]}
                    fontSize="18px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Contele Câmeras
                  </Text>
                  <Text
                    color={Gray[400]}
                    fontSize="14px"
                    lineHeight="19px"
                    fontWeight="400"
                    textAlign="center"
                  >
                    Modalidade do Contele Fleet que engloba todas as funções do Contele Tracker além das imagens devido à utilização das câmeras.
                  </Text>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '10px',
                }}
                >
                  <Text
                    color={Gray[500]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="600"
                  >
                    Quantidade de veículos com Câmeras
                  </Text>
                  <div style={{ display: 'flex', gap: '10px', width: '100%' }}>
                    <ButtonWithIcon
                      icon="minus"
                      customBackgroundColor={Gray[100]}
                      border={`1px solid ${Gray[250]}`}
                      customIconColor={Gray[400]}
                      height="32px"
                      iconOptions={{ width: '14px', height: '14px' }}
                      onClick={() => {
                        if (conteleCamerasCount === 0) return;
                        setValue('conteleCamerasCount', conteleCamerasCount - 1, { shouldValidate: true });
                      }}
                    />
                    <MaskedInput
                      control={control}
                      name="conteleCamerasCount"
                      placeholder="Digite a quantidade de veículos"
                      format="numeric"
                      containerWidth="100%"
                      style={{ border: `1px solid ${Gray[250]}`, borderRadius: '5px' }}
                    />
                    <ButtonWithIcon
                      icon="plus"
                      customBackgroundColor={Gray[100]}
                      border={`1px solid ${Gray[250]}`}
                      customIconColor={Gray[400]}
                      height="32px"
                      iconOptions={{ width: '14px', height: '14px' }}
                      onClick={() => setValue('conteleCamerasCount', conteleCamerasCount + 1, { shouldValidate: true })}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '8px',
              backgroundColor: Gray[200],
              borderRadius: '5px',
              padding: '20px',
            }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Icon
                  color={Gray[400]}
                  icon="exclamationCircle"
                  style={{ width: '16px', height: '16px' }}
                />
                <Text
                  color={Gray[400]}
                  fontSize="16px"
                  lineHeight="19px"
                  fontWeight="700"
                >
                  Suporte Técnico
                </Text>
              </div>
              <Text
                color={Gray[400]}
                fontSize="14px"
                lineHeight="19px"
                fontWeight="400"
              >
                Nosso horário de atendimento é de seg. a sex, das 08:00 às 18h. Fora desse horário, você poderá utilizar a nossa Central de Ajuda Online 24h, que pode ser acessada pelo aplicativo ou sistema.
              </Text>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <Checkbox
                  type="checkbox"
                  control={control}
                  name="acceptTerms"
                  id="acceptTerms"
                  innerRef={register({
                    required: true,
                  })}
                />
                <Text
                  color={Gray[400]}
                  fontSize="14px"
                  lineHeight="19px"
                  fontWeight="400"
                  textAlign="center"
                >
                  Sim, estou ciente.
                </Text>
              </div>
            </div>

            {!isValid && (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                backgroundColor: Orange[100],
                borderRadius: '5px',
                padding: '20px',
              }}
              >
                <div style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <Icon
                    color={Orange[400]}
                    icon="exclamationTriangle"
                    style={{ width: '16px', height: '16px' }}
                  />
                  <Text
                    color={Orange[400]}
                    fontSize="16px"
                    lineHeight="19px"
                    fontWeight="700"
                  >
                    Requisitos para Prosseguir
                  </Text>
                </div>
                <div style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
                >
                  {((conteleSystemCount || 0) + (conteleTrackerCount || 0) + (conteleCamerasCount || 0)) < 4 && (
                    <Text
                      color={Orange[400]}
                      fontSize="14px"
                      lineHeight="19px"
                      fontWeight="400"
                    >
                      • Você precisa ter pelo menos 4 veículos no total (todas as modalidades somadas)
                    </Text>
                  )}
                  {!watch('acceptTerms') && (
                    <Text
                      color={Orange[400]}
                      fontSize="14px"
                      lineHeight="19px"
                      fontWeight="400"
                    >
                      • É necessário aceitar os termos de suporte técnico
                    </Text>
                  )}
                </div>
              </div>
            )}
          </div>

          <ActionPortal>
            <DefaultActionButtons
              theme={theme}
              isValid={isValid}
              backButtonStyle={{
                iconPosition: 'left',
                border: 'none',
                customBackgroundColor: 'transparent',
                customIconColor: Gray[400],
                customTextColor: Gray[400],
                title: 'Passo Anterior',
              }}
              nextButtonStyle={{
                customBackgroundColor: Purple[500],
                customIconColor: Gray[100],
                customTextColor: Gray[100],
                title: 'Próximo Passo',
              }}
              onCancel={onCancel}
              onSubmit={() => handleSubmit(handleFormSubmitWithReset)()}
            />
          </ActionPortal>
        </Form>
      </Step>
    </div>
  );
}

VehicleManager.propTypes = StepPropTypes;
